import React, { useRef, useEffect } from 'react';
import { KEYS_CHARCODE } from '../consts.js';
import TextInputModalContainer from './TextInputModalContainer.js';
import TextInput from '../Components/TextInput.js';
import 'wix-rich-content-common';
import '../url-input-modal-018415d9.js';
import '../style-inject.es-746bb8ed.js';
import 'classnames';
import '../Components/ModalCloseButton.js';
import '../Icons/ModalsCloseIcon.js';
import '../Components/SettingsMobileHeader.js';
import '../Components/Button.js';
import 'wix-rich-content-common/libs/Tooltip';
import 'lodash';
import '../Icons/SearchIcon.js';
import '../Icons/ErrorIcon.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const NewUrlInputModal = (props) => {
  const {
    dataHook,
    onConfirm,
    onCloseRequested,
    submittedInvalidUrl,
    errorMessage,
    placeholder,
    onInputChange,
    input,
    onDoubleClick
  } = props;
  const InputRef = useRef(null);
  useEffect(() => {
    const input2 = InputRef.current;
    input2.setSelectionRange(0, input2.value.length);
    setTimeout(() => input2.focus(), 0);
  }, []);
  const onUrlChange = (url) => {
    onInputChange(url);
  };
  const handleKeyPress = (event) => {
    if (event.charCode === KEYS_CHARCODE.ENTER) {
      onConfirm();
    }
    if (event.charCode === KEYS_CHARCODE.ESCAPE) {
      onCloseRequested == null ? void 0 : onCloseRequested();
    }
  };
  return /* @__PURE__ */ React.createElement(TextInputModalContainer, __spreadValues({}, props), /* @__PURE__ */ React.createElement(
    TextInput,
    {
      inputRef: InputRef,
      type: "url",
      id: "dropdown-text-input",
      onKeyPress: handleKeyPress,
      onChange: onUrlChange,
      value: input,
      error: submittedInvalidUrl && errorMessage,
      placeholder,
      theme: props.theme,
      "data-hook": `${dataHook}Input`,
      autoComplete: "off",
      onDoubleClick,
      style: { paddingLeft: "12px" }
    }
  ));
};

export { NewUrlInputModal as default };
//# sourceMappingURL=NewUrlInputModal.js.map
